export const UPDATE_COLLECTIONS = 'UPDATE_COLLECTIONS';
export const UPDATE_COLLECTIONS_V2 = 'UPDATE_COLLECTIONS_V2';
export const UPDATE_ENTITY = 'UPDATE_ENTITY';